import React from "react"
import { createPortal } from "react-dom"

export function AlertModal({
  open,
  title = "Notice",
  description = "",
  actionLabel = "OK",
  secondaryActionLabel = "",
  onSecondaryAction,
  onClose,
}) {
  if (!open) return null

  return createPortal(
    <div className="fixed inset-0 z-[1000] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border border-gray-700 bg-gray-900/95 shadow-2xl">
        <div className="px-5 pt-5 pb-3">
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          {description ? (
            <p className="mt-2 text-sm text-gray-300 leading-relaxed whitespace-pre-line break-all">{description}</p>
          ) : null}
        </div>
        <div className="px-5 pb-5 flex justify-end gap-2">
          {secondaryActionLabel && typeof onSecondaryAction === "function" ? (
            <button
              type="button"
              onClick={onSecondaryAction}
              className="rounded-lg border border-gray-600 bg-gray-800 px-4 py-2 text-sm font-medium text-gray-100 hover:bg-gray-700 transition-colors"
            >
              {secondaryActionLabel}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-emerald-500 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-600 transition-colors"
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

